module.exports = __webpack_public_path__ + "assets/icon-fund.ef1d6aa5.svg";